const WALLYFRAME_FAVORITES_KEY = 'wallyframe:favorites:v1';
const WALLYFRAME_LAST_VISIT_KEY = 'wallyframe:last-visit:v1';
const WALLYFRAME_RECENT_EVENTS = new Map();
let WALLYFRAME_ANALYTICS_ALLOWED = false;

function refreshWallyFrameAnalyticsPermission() {
  const privacy = window.Shopify?.customerPrivacy;
  WALLYFRAME_ANALYTICS_ALLOWED =
    typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed();
}

function initPrivacyAwareAnalytics() {
  const shopify = window.Shopify;
  if (!shopify) return;

  refreshWallyFrameAnalyticsPermission();
  document.addEventListener('visitorConsentCollected', refreshWallyFrameAnalyticsPermission);

  if (typeof shopify.loadFeatures !== 'function') return;
  shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) refreshWallyFrameAnalyticsPermission();
  });
}

function publishWallyFrameEvent(name, data = {}) {
  if (!WALLYFRAME_ANALYTICS_ALLOWED) return;
  const analytics = window.Shopify?.analytics;
  if (typeof analytics?.publish !== 'function') return;

  const payload = {
    ...data,
    path: window.location.pathname,
    language: document.documentElement.lang || 'de',
  };
  const signature = `${name}:${JSON.stringify(payload)}`;
  const now = Date.now();
  if (now - (WALLYFRAME_RECENT_EVENTS.get(signature) || 0) < 750) return;
  WALLYFRAME_RECENT_EVENTS.set(signature, now);

  try {
    const result = analytics.publish(`wallyframe:${name}`, payload);
    if (result && typeof result.catch === 'function') result.catch(() => {});
  } catch {
    return;
  }
}

function readFavorites() {
  try {
    const value = JSON.parse(localStorage.getItem(WALLYFRAME_FAVORITES_KEY) || '[]');
    return new Set(Array.isArray(value) ? value : []);
  } catch {
    return new Set();
  }
}

function writeFavorites(favorites) {
  try {
    localStorage.setItem(WALLYFRAME_FAVORITES_KEY, JSON.stringify([...favorites]));
  } catch {
    return;
  }
}

function syncFavoriteButtons(scope, favorites) {
  scope.querySelectorAll('[data-wf-favorite]').forEach((button) => {
    const isSaved = favorites.has(button.dataset.wfKey);
    button.setAttribute('aria-pressed', String(isSaved));
    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-label', isSaved ? button.dataset.wfRemoveLabel : button.dataset.wfSaveLabel);
    const label = button.querySelector('[data-wf-favorite-label]');
    if (label) label.textContent = isSaved ? button.dataset.wfSavedText : button.dataset.wfSaveText;
  });
}

function announceFavoriteCounts(favorites) {
  document.querySelectorAll('[data-wf-saved-count]').forEach((count) => {
    count.textContent = String(favorites.size);
  });
  document.dispatchEvent(new CustomEvent('wallyframe:favorites', { detail: { count: favorites.size } }));
}

function toggleFavorite(button) {
  const favorites = readFavorites();
  const key = button.dataset.wfKey;
  if (!key) return;
  const saved = !favorites.has(key);
  if (saved) favorites.add(key);
  else favorites.delete(key);
  writeFavorites(favorites);
  syncFavoriteButtons(document, favorites);
  announceFavoriteCounts(favorites);
  publishWallyFrameEvent('motif_preference', { product_handle: key, saved });
}

function markNewCards(section) {
  let lastVisit = 0;
  try {
    lastVisit = Number(localStorage.getItem(WALLYFRAME_LAST_VISIT_KEY) || 0);
  } catch {
    lastVisit = 0;
  }

  section.querySelectorAll('[data-wf-card]').forEach((card) => {
    const published = Number(card.dataset.wfPublished || 0) * 1000;
    const badge = card.querySelector('[data-wf-new]');
    if (badge) badge.hidden = lastVisit > 0 && published <= lastVisit;
  });

  window.setTimeout(() => {
    try {
      localStorage.setItem(WALLYFRAME_LAST_VISIT_KEY, String(Date.now()));
    } catch {
      return;
    }
  }, 3000);
}

function initDiscovery(section) {
  if (section.dataset.wfReady === 'true') return;
  section.dataset.wfReady = 'true';

  const cards = [...section.querySelectorAll('[data-wf-card]')];
  const dialog = section.querySelector('[data-wf-dialog]');
  const dialogContent = dialog?.querySelector('[data-wf-dialog-content]');
  const dialogStatus = dialog?.querySelector('[data-wf-dialog-status]');
  const filterButton = section.querySelector('[data-wf-filter-saved]');
  const emptyState = section.querySelector('[data-wf-saved-empty]');
  let activeIndex = 0;

  const updateFilter = () => {
    if (!filterButton) return;
    const favorites = readFavorites();
    const filterActive = filterButton.getAttribute('aria-pressed') === 'true';
    let visibleCount = 0;
    cards.forEach((card) => {
      const visible = !filterActive || favorites.has(card.dataset.wfKey);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    if (emptyState) emptyState.hidden = !filterActive || visibleCount > 0;
    filterButton.querySelector('[data-wf-filter-label]').textContent = filterActive
      ? filterButton.dataset.wfAllText
      : filterButton.dataset.wfSavedText;
  };

  const renderDialog = (index) => {
    if (!dialog || !dialogContent || cards.length === 0) return;
    activeIndex = (index + cards.length) % cards.length;
    const template = cards[activeIndex].querySelector('template[data-wf-template]');
    if (!template) return;
    dialogContent.replaceChildren(template.content.cloneNode(true));
    syncFavoriteButtons(dialogContent, readFavorites());
    if (dialogStatus) {
      dialogStatus.textContent = dialogStatus.dataset.wfStatus
        .replace('[current]', String(activeIndex + 1))
        .replace('[total]', String(cards.length));
    }
  };

  const openDialog = (index) => {
    renderDialog(index);
    if (dialog && !dialog.open) dialog.showModal();
  };

  section.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-wf-favorite]');
    if (favorite) {
      event.preventDefault();
      toggleFavorite(favorite);
      updateFilter();
      return;
    }

    const opener = event.target.closest('[data-wf-open]');
    if (opener) {
      const card = opener.closest('[data-wf-card]');
      publishWallyFrameEvent('motif_opened', {
        product_handle: card?.dataset.wfKey || '',
        source: 'discovery',
      });
      openDialog(cards.indexOf(card));
      return;
    }

    if (event.target.closest('[data-wf-random]')) {
      const visibleCards = cards.filter((card) => !card.hidden);
      const pool = visibleCards.length > 0 ? visibleCards : cards;
      const chosen = pool[Math.floor(Math.random() * pool.length)];
      openDialog(cards.indexOf(chosen));
      return;
    }

    if (event.target.closest('[data-wf-filter-saved]')) {
      const active = filterButton.getAttribute('aria-pressed') === 'true';
      filterButton.setAttribute('aria-pressed', String(!active));
      updateFilter();
      return;
    }

    if (event.target.closest('[data-wf-dialog-close]')) dialog?.close();
    if (event.target.closest('[data-wf-dialog-previous]')) renderDialog(activeIndex - 1);
    if (event.target.closest('[data-wf-dialog-next]')) renderDialog(activeIndex + 1);
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') renderDialog(activeIndex - 1);
    if (event.key === 'ArrowRight') renderDialog(activeIndex + 1);
  });

  document.addEventListener('wallyframe:favorites', updateFilter);
  markNewCards(section);
  const favorites = readFavorites();
  syncFavoriteButtons(section, favorites);
  announceFavoriteCounts(favorites);
  updateFilter();
}

function initRoomPreview(section) {
  if (section.dataset.wfReady === 'true') return;
  section.dataset.wfReady = 'true';
  const scene = section.querySelector('.wallyframe-room__scene');
  const frame = section.querySelector('[data-wf-room-frame]');
  const sizeOutput = section.querySelector('[data-wf-room-size]');
  const dimensionOutput = section.querySelector('[data-wf-room-dimension]');
  const orientation = section.dataset.wfOrientation || 'auto';
  const imageAspectRatio = Number(section.dataset.wfImageAspectRatio || 1);
  let activeSizeButton;

  const getScale = () => {
    if (!scene) return 1;
    const wallWidthCm = scene.clientWidth < 560 ? 240 : 360;
    const wallHeightCm = 220;
    return Math.min(scene.clientWidth / wallWidthCm, (scene.clientHeight * 0.72) / wallHeightCm);
  };

  const setSize = (button) => {
    const dimensions = String(button.dataset.wfSizeValue || button.textContent)
      .match(/(\d+(?:[.,]\d+)?)\s*(?:x|×)\s*(\d+(?:[.,]\d+)?)/i);
    if (!dimensions) return;
    let width = Number(dimensions[1].replace(',', '.'));
    let height = Number(dimensions[2].replace(',', '.'));
    const isLandscape = orientation === 'landscape' || (orientation === 'auto' && imageAspectRatio > 1.02);
    const isPortrait = orientation === 'portrait' || (orientation === 'auto' && imageAspectRatio < 0.98);
    if (isLandscape && height > width) [width, height] = [height, width];
    if (isPortrait && width > height) [width, height] = [height, width];
    const scale = getScale();
    const displayWidth = width * scale;
    const displayHeight = height * scale;
    activeSizeButton = button;
    frame?.style.setProperty('--wf-room-frame-width', `${displayWidth}px`);
    frame?.style.setProperty('--wf-room-frame-height', `${displayHeight}px`);
    scene?.style.setProperty('--wf-room-frame-height', `${displayHeight}px`);
    scene?.style.setProperty('--wf-room-bench-width', `${180 * scale}px`);
    scene?.style.setProperty('--wf-room-bench-top-height', `${12 * scale}px`);
    scene?.style.setProperty('--wf-room-bench-leg-height', `${34 * scale}px`);
    section.querySelectorAll('[data-wf-room-size-button]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
    const label = button.querySelector('span')?.textContent?.trim() || button.dataset.wfSizeValue || '';
    if (sizeOutput) sizeOutput.textContent = label;
    if (dimensionOutput) dimensionOutput.textContent = label;
  };

  section.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('[data-wf-room-size-button]');
    if (sizeButton) {
      setSize(sizeButton);
      const sizeValue = sizeButton.dataset.wfSizeValue;
      publishWallyFrameEvent('size_compared', {
        product_handle: section.dataset.wfKey || '',
        size: sizeValue || '',
        source: 'room_preview',
      });
      const pickerInputs = document.querySelectorAll('variant-picker input[data-option-name]');
      const matchingInput = [...pickerInputs].find((input) => input.value === sizeValue);
      if (matchingInput && !matchingInput.checked) matchingInput.click();
    }
    const favorite = event.target.closest('[data-wf-favorite]');
    if (favorite) toggleFavorite(favorite);
  });

  const selectedSize = section.querySelector('[data-wf-room-size-button][aria-pressed="true"]')
    || section.querySelector('[data-wf-room-size-button]');
  if (selectedSize) setSize(selectedSize);

  const resizeObserver = new ResizeObserver(() => {
    if (activeSizeButton) window.requestAnimationFrame(() => setSize(activeSizeButton));
  });
  if (scene) resizeObserver.observe(scene);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
    const selectedOption = target instanceof HTMLSelectElement ? target.options[target.selectedIndex] : target;
    const optionName = String(selectedOption.dataset.optionName || target.dataset.optionName || '').toLowerCase();
    const value = target instanceof HTMLSelectElement ? target.value : target.value;
    if (/(size|format|gr[oö][sß]e)/i.test(optionName)) {
      const button = [...section.querySelectorAll('[data-wf-room-size-button]')]
        .find((item) => item.dataset.wfSizeValue === value);
      if (button && button !== activeSizeButton) {
        setSize(button);
        publishWallyFrameEvent('size_compared', {
          product_handle: section.dataset.wfKey || '',
          size: value,
          source: 'product_picker',
        });
      }
      return;
    }
    if (/(frame color|frame colour|rahmenfarbe)/i.test(optionName)) {
      publishWallyFrameEvent('finish_selected', {
        product_handle: section.dataset.wfKey || '',
        finish: value,
      });
    }
  });
  const favorites = readFavorites();
  syncFavoriteButtons(section, favorites);
  announceFavoriteCounts(favorites);
}

function initFirstRelease(section) {
  if (section.dataset.wfTrackingReady === 'true') return;
  section.dataset.wfTrackingReady = 'true';
  section.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-wf-product-choice]');
    if (!choice) return;
    publishWallyFrameEvent('material_selected', {
      motif: section.dataset.wfMotif || '',
      material: choice.dataset.wfMaterial || '',
      product_handle: choice.dataset.wfProductHandle || '',
      source: 'homepage',
    });
  });
}

function enhanceCookieBanner() {
  const dialog = document.querySelector('#shopify-pc__banner .shopify-pc__banner__dialog');
  if (!dialog || dialog.querySelector('.wallyframe-cookie-question')) return false;
  const question = document.createElement('p');
  question.className = 'wallyframe-cookie-question';
  question.textContent = document.body.dataset.wfCookieQuestion || '';
  dialog.prepend(question);
  return true;
}

function initCookieBannerEnhancement() {
  if (enhanceCookieBanner()) return;
  const observer = new MutationObserver(() => {
    if (enhanceCookieBanner()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
}

function initWallyFrameExperience(root = document) {
  root.querySelectorAll('[data-wf-discovery]').forEach(initDiscovery);
  root.querySelectorAll('[data-wf-room]').forEach(initRoomPreview);
  root.querySelectorAll('[data-wf-release]').forEach(initFirstRelease);
}

initPrivacyAwareAnalytics();
initWallyFrameExperience();
initCookieBannerEnhancement();
document.addEventListener('shopify:section:load', (event) => initWallyFrameExperience(event.target));
